import styles from './Feedback.module.scss'
import { ContactEmailInput, ContactSwitch, HelpText } from './FeedbackSections'

import { useMemo, useState } from 'react'

import Button from 'Molecules/Button'

import Form from 'Atoms/Form'
import Typography from 'Atoms/Typography'

const ProductSuggestion = ({
  contactOkay,
  setContactOkay,
  email,
  onEmailChange,
  EMAILINPUTID,
  isPositive,
  name,
  searchProvider,
  generalFeedbackSegmentEvent,
  generalFeedbackText,
}) => {
  const [partNumber, setPartNumber] = useState('')
  const [productUrl, setProductUrl] = useState('')

  const segmentEvent = useMemo(() => {
    return {
      event: 'Product Suggestion Submitted',
      properties: {
        part_number: partNumber,
        product_url: productUrl,
        okay_to_contact: contactOkay,
        entered_email: email,
      },
    }
  }, [contactOkay, email, partNumber, productUrl])

  if (searchProvider) segmentEvent.properties.search_provider = searchProvider

  const segmentEvents = useMemo(
    () => [segmentEvent, ...(generalFeedbackText?.trim() ? [generalFeedbackSegmentEvent] : [])],
    [segmentEvent, generalFeedbackText, generalFeedbackSegmentEvent],
  )

  return (
    <div className={styles.productSuggestionContainer}>
      <div className={styles.suggestionInputs}>
        <div className={styles.section}>
          <Form.TextArea
            autoFocus
            label={
              <>
                <strong>Part Number</strong> (if known)
              </>
            }
            placeholder="Enter part number"
            value={partNumber}
            onChange={(e) => setPartNumber(e.target.value)}
            className={styles.textBox}
            rows={1}
          />
        </div>

        <div className={styles.section}>
          <Form.TextArea
            label={
              <>
                <strong>Product URL</strong> (optional)
              </>
            }
            placeholder="https://example.com/product"
            value={productUrl}
            onChange={(e) => setProductUrl(e.target.value)}
            className={styles.textBox}
            rows={1}
          />
        </div>
      </div>

      <Button
        className={styles.submitButton}
        segmentEvents={segmentEvents}
        brand={'secondary'}
        size="small"
        text="Submit Feedback and Suggestion"
        data-testid={`${name}FeedbackSubmit`}
        type="submit"
        disabled={(!partNumber && !productUrl) || (contactOkay && !email)}
      />

      <HelpText />
    </div>
  )
}

export default ProductSuggestion
